import { registerGlobalCaptchaHandler } from '@innolab-trader/tradovate-transport'

export interface RecaptchaHandlerOptions {
  openRecaptchaModal: (options: { siteKey: string; title?: string; message?: string }) => Promise<string | null>
  siteKey?: string
}

export function registerRecaptchaHandler(options: RecaptchaHandlerOptions): void {
  const { openRecaptchaModal, siteKey: providedSiteKey } = options
  registerGlobalCaptchaHandler(async (pTicket: string, pTime: number) => {
    console.log(`[Recaptcha] P-ticket rate limit detected: ticket=${pTicket}, penalty=${pTime}s`)
    const siteKey = providedSiteKey || '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
    if (siteKey === '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI') {
      console.warn('[Recaptcha] Using Google test key. Configure VITE_RECAPTCHA_SITE_KEY for production.')
    }
    try {
      const token = await openRecaptchaModal({
        siteKey,
        title: 'Rate Limit Verification',
        message: `Too many requests. Please wait ${pTime} seconds and complete the security check.`
      })
      if (!token) throw new Error('Recaptcha verification was cancelled by user')
      return token
    } catch (error) {
      console.error('[Recaptcha] Verification failed:', error)
      throw new Error(`Recaptcha verification failed: ${error instanceof Error ? error.message : 'Unknown error'}`)
    }
  })
  console.log('✅ [Recaptcha] Global handler registered')
}

